import React from 'react';
import FestivalHero from './FestivalHero';

function ApplicationForm() {
    return (
        <FestivalHero
            year={2026}
            title="Ethos Ankara Uluslararası Tiyatro Festivali"
            poster="images/18.jpg"
        />
    );
}

export default ApplicationForm;
